import axiosIns from '../../../xaxios';
import { obtenerUrlAPIComisiones } from '../utils/funciones';

export default {
  async findAll(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones('inscripciones-documentos-personas-excel'), {
      ...opciones,
      responseType: 'blob',
    });
  },
  async findAllAgrupado(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones('inscripciones-documentos-personas-excel/agrupado'), {
      ...opciones,
      responseType: 'blob',
    });
  },
  async reporteDocumentos(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones('inscripciones-documentos-personas-excel/reporte-documentos'), {
      ...opciones,
      responseType: 'blob',
    });
  },
  async findAllConDatos(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones('inscripciones-documentos-personas-excel/con-datos'), {
      ...opciones,
      responseType: 'blob',
    });
  },
  async findAllConDatosMultiples(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones('inscripciones-documentos-personas-excel/con-datos-multiples'), {
      ...opciones,
      responseType: 'blob',
    });
  },
  async documentosPorProgramaId(programaId, opciones = { params: {} }) {
    return await axiosIns.get(
      obtenerUrlAPIComisiones(`inscripciones-documentos-personas-excel/documentos-por-programa/${programaId}`),
      {
        ...opciones,
        responseType: 'blob',
      },
    );
  },
};
